import { SocketCustomErrorMessageType } from "~/js/graph/socketCustomErrorMessage";
import type { nodeNewExecutor } from "~/js/utilities/changeNodeExecutorOnCustom";
import { Default_Executor_Text, execute } from "~/js/utilities/executor";
import { findSocket } from "~/solidJs/shared/helpers/nodeHelpers";
import { getImageDimensionsFromFile } from "~/solidJs/shared/helpers/validateImages";
import { ExecutionStatus, NodeExecutor } from "../../node-executor";

export const runWayExecutor: nodeNewExecutor = (node, _layout, _initialExecutor) => {
	const inputImg = findSocket("init_img", node);

	const executor = new NodeExecutor(node);
	executor.useEnterExitTriggers();
	executor.setStatusEnabled(true);
	executor.updateStatus(ExecutionStatus.Ready, Default_Executor_Text);
	executor.setExecuteFunction(async (cancelController: AbortController) => {
		const inputImage = await inputImg?.getValue();
		if (!inputImage || !inputImg) {
			executor.updateStatus(
				ExecutionStatus.Error,
				inputImg?.getErrorMessage(SocketCustomErrorMessageType.EmptyNonOptional) ||
					`Input ${inputImg?.layout?.label} is empty`,
				"error_params"
			);
			return;
		}
		const imgResolution = await getImageDimensionsFromFile(inputImage);
		if (!imgResolution) {
			executor.updateStatus(
				ExecutionStatus.Error,
				"Input image has unknown format",
				"error_params"
			);
			return;
		}
		const inputRatio = imgResolution.width / imgResolution.height;
		if (inputRatio < 0.5 || inputRatio > 2) {
			executor.updateStatus(
				ExecutionStatus.Error,
				`Your image width/height ratio should be between 0.5 and 2. Your ratio: ${inputRatio === Math.round(inputRatio) ? inputRatio : inputRatio.toFixed(1)}`,
				"error_params"
			);
			return;
		}

		try {
			await execute(node, executor, cancelController);
		} catch (e) {
			console.error(e);
		}
	});
};
